var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupleOfoghi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.9,22H27c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h1v-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1L29.9,22L29.9,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3,22h-3.6c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h3.6c0.5,0,1,0.4,1,1C24.3,21.5,23.9,22,23.3,22z M16.1,22h-3.6 c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h3.6c0.5,0,1,0.4,1,1C17,21.5,16.6,22,16.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,22H5.8v-3c0-0.5,0.4-1,1-1s1,0.4,1,1v1h1c0.5,0,1,0.4,1,1C9.7,21.5,9.2,22,8.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,17c-0.5,0-1-0.4-1-1v-2.9c0-0.5,0.4-1,1-1s1,0.4,1,1V16C7.7,16.5,7.3,17,6.8,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,11c-0.5,0-1-0.4-1-1V7h2.9c0.5,0,1,0.4,1,1s-0.4,1-1,1h-1v1C7.7,10.5,7.3,11,6.8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,9h-3.6c-0.5,0-1-0.4-1-1s0.4-1,1-1h3.6c0.5,0,1,0.4,1,1S23.7,9,23.1,9z M15.9,9h-3.6c-0.5,0-1-0.4-1-1s0.4-1,1-1h3.6 c0.5,0,1,0.4,1,1S16.4,9,15.9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,11c-0.5,0-1-0.4-1-1V9h-1c-0.5,0-1-0.4-1-1s0.4-1,1-1h3v3C29.9,10.5,29.5,11,28.9,11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,16.9c-0.5,0-1-0.4-1-1V13c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v2.9C29.9,16.4,29.5,16.9,28.9,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1,30H9.7V16h15.4V30z M10.6,29h13.6V17H10.6V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1,13H0V0h25.1V13z M1,12h23.2V1H1V12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleOfoghi);
export default __webpack_public_path__ + "static/media/couple_ofoghi.78fde6de12fd45833a088c70759e8c3a.svg";
export { ForwardRef as ReactComponent };